/** ******************************************************************************* */
/* Search list -- showing markers on the map according to bounding box ajax search */
/** ******************************************************************************* */
Bingo.Map.SearchList = function (mapSelector, formMapping, resultListSelector, searchNameSelector, originPage, loadMarkerInfo, mapLoadMore, viewType = null, adManagerId = null) {
    Bingo.Map.PositionSelection.call(this, mapSelector, formMapping, originPage);
    Bingo.Map.SearchList.adManagerId = adManagerId;
    Bingo.Map.SearchList.adsSlotsDefined = false;
    if (window.matchMedia('(max-width: 576px)').matches) {
        Bingo.Map.DEFAULT_ZOOM = 9;
    }
    // Overrides of PositionSelection fields
    this.mapSelector = mapSelector;
    this.mode = Bingo.Map.MODE_SEARCH_LIST;
    this.VIEW_TYPE_KEY = 'searchListViewType';
    this.VIEW_TYPE_MAP = 'map';
    this.VIEW_TYPE_LIST = 'list';
    if (viewType === this.VIEW_TYPE_MAP || viewType === this.VIEW_TYPE_LIST) {
        this.viewType = viewType;
    } else {
        this.viewType = Bingo.LocalStorage.get(this.VIEW_TYPE_KEY, this.VIEW_TYPE_LIST);
    }
    this.NO_LOCATION_ZOOM = 9;
    this.DRAGGABLE_CIRCLE = false;
    this.MARKER_PROTOTYPE = {
        url: '/src/images/markers/target.svg?{{buildVersion}}',
        size: new google.maps.Size(64, 64),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(16, 16),
    };

    // Fields relevant for SearchList
    this.appendToXhr = {};
    this.query = null;
    this.offset = 0;
    this.offset2 = 0;
    this.radiusOpacity = Bingo.Map.Marker.RADIUS_OPACITY;
    this.clusterer = null;

    this.resultListSelector = resultListSelector;
    this.searchNameSelector = searchNameSelector;
    this.markers = {};
    this.markersInfos = {};

    this.markersInfosSizeStart = 15;
    this.markersInfosSizeActualLimit = 0;
    this.markersInfosSizeStep = mapLoadMore;
    this.markersInfosSize = 0;
    this.markersListAdPositionInStep = 4;

    this.loadMoreEnabled = true;
    this.loadMoreTriggerHeight = 600;

    this.window = null;
    this.loadMarkerInfo = loadMarkerInfo;
    this.toLoad = {
        normal: [],
        fuzzy: [],
    };
    this.notLoaded = [];
    this.localities = [];

    this.onNoLocationCallback = null;

    this.defaultLocation = this.parseDefaultLocation(formMapping.location);

    this.MAX_ZOOM_LEVEL = 16;
    this.LIMIT = 1000;
    this.idleTimeDelay = 600;
    this.searchGridEnabled = false;
    if (this.viewType === this.VIEW_TYPE_MAP) {
        this.enableMap();
    } else {
        this.disableMap();
    }
    this.initSearchResultsGrid();
    this.onResize();
    $(window).resize(() => this.onResize());
};
Bingo.Map.SearchList.prototype = Object.create(Bingo.Map.PositionSelection.prototype);

Bingo.Map.SearchList.prototype.onResize = function () {
    const headerHeight = $('.js-layout__header').height();
    const windowHeight = $(window).height();
    const sidebarContentHeight = $('.js-search__sidebarContent').height();
    const sidebarContentTop = ((sidebarContentHeight + 30) > (windowHeight - headerHeight)) ? (windowHeight - sidebarContentHeight) : headerHeight + 30;

    $('.js-mapOnDetail').css('height', `${windowHeight - headerHeight}px`);
    if (this.showMap) {
        $('.js-search__contentArea').css('height', `${windowHeight - headerHeight}px`);
    } else {
        $('.js-search__sidebarContent').css('top', `${sidebarContentTop}px`);
        $('.js-search__contentArea').css('height', 'auto');
    }
};

Bingo.Map.SearchList.getAdZone = id => `<div class="T-search__resultsAdCover js-searchResultsGrid-item js-searchResultsGrid-itemAd"><div class="A-ad js-Ad adBanner d-block" id="js-ad-manager-zone-search-${id}"></div></div>`;

Bingo.Map.SearchList.prototype.getFirstPageAppendedContent = function () {
    let content = $('<div />').append($('.js-searchList__firstPageAppendedContent').clone()).html();
    content = `<div class="T-search__resultItem js-searchResultsGrid-item d-lg-none">${content}</div>`;
    return content;
};

Bingo.Map.SearchList.prototype.init = function () {
    Bingo.Map.PositionSelection.prototype.init.call(this);

    if (!this.lastLocation) {
        this.noLocation();
    }

    this.clusterer = this.createMarkerClusterer(this.getArea(), this.markers);

    // fire delayed search, when map is idle
    this.getArea().addListener('idle', () => {
        if (this.query
            && this.query.data.draw !== '1'
            && this.showMap
            && this.query.data.polygon !== this.getBoundingBoxPolygon()
            && (this.query.data.localityId === '' || Number.isNaN(parseInt(this.query.data.localityId)))
        ) {
            const idleTimeout = window.setTimeout(this.load.bind(this, true), this.idleTimeDelay);
            google.maps.event.addListenerOnce(this.area, 'bounds_changed', () => {
                window.clearTimeout(idleTimeout);
            });
        }
    });

    // showing and hiding images
    const $searchList = $('.js-searchList');
    const $btnHideImages = $('.js-sidebar__showPhotosToggler--hide');
    const $btnShowImages = $('.js-sidebar__showPhotosToggler--show');
    $btnShowImages.click(() => {
        Cookies.remove('hidden-images-search-page');
        $searchList.removeClass('-withoutImage');
        $btnShowImages.hide();
        $btnHideImages.show();
        this.reloadSearchResultsGrid();
        return false;
    });
    $btnHideImages.click(() => {
        Cookies.set('hidden-images-search-page', true);
        $searchList.addClass('-withoutImage');
        $btnHideImages.hide();
        $btnShowImages.show();
        this.reloadSearchResultsGrid();
        return false;
    });

    if (Bingo.Map.SearchList.adManagerId) {
        Bingo.Map.SearchList.prototype.setAds(Bingo.Map.SearchList.adManagerId);
        Bingo.AdManager.init('js-ad-manager-zone-search-sidebar-1');
        Bingo.AdManager.init('js-ad-manager-zone-search-sidebar-2');
    }

    // infinity scroll listView
    $(window).scroll(() => {
        this.loadMore();
    });
    // infinity scroll mapView
    $('.js-search__contentArea.-map').scroll(() => {
        this.loadMore();
    });
};

Bingo.Map.SearchList.prototype.loadMore = function () {
    const $resultList = $(`#${this.resultListSelector}`);
    // Prevent load more before completed
    if (!this.loadMoreEnabled) {
        return;
    }
    const $loadMoreTrigger = (($resultList.height() + $resultList.offset().top - $(window).scrollTop() - $(window).height() - this.loadMoreTriggerHeight) > 0) ? 0 : 1;
    if (!$loadMoreTrigger) {
        return;
    }
    let normalOffersAdded = 0;
    this.markersInfosSizeActualLimit = this.markersInfosSizeActualLimit + this.markersInfosSizeStep;

    const generated = [];
    const elms = document.getElementsByClassName('marker_offer_info');
    for (let i = 0; i < elms.length; i++) {
        const el = elms[i];
        if (el.children.length === 1) {
            generated.push(parseInt(el.dataset.id));
        }
    }

    const offersLoaded = generated.length - this.markersInfosSizeStart;
    const adNumber = offersLoaded / this.markersInfosSizeStep + 2;

    //  Normal result list
    const listElementHtmlToLoad = this.toLoad.normal
        .filter(value => generated.indexOf(value) < 0)
        .splice(0, this.markersInfosSizeStep)
        .map((itemId, i) => {
            this.markersInfosSize += 1;
            normalOffersAdded += 1;

            if (Bingo.Map.SearchList.adManagerId && i === (this.markersListAdPositionInStep - 1)) {
                return Bingo.Map.SearchList.getAdZone(adNumber) + this.generateOfferToList(itemId);
            }
            return this.generateOfferToList(itemId);
        })
        .join('');
    this.appendItemsToListElement(this.getResultsListElement(), listElementHtmlToLoad);

    //  Fuzzy result list
    if (normalOffersAdded < this.markersInfosSizeStep) {
        if (this.markersInfosSize < this.markersInfosSizeActualLimit) {
            const fuzzyListElementHtmlToLoad = this.toLoad.fuzzy
                .filter(value => generated.indexOf(value) < 0)
                .splice(0, this.markersInfosSizeStep - normalOffersAdded)
                .map((itemId, i) => {
                    this.markersInfosSize += 1;

                    if (Bingo.Map.SearchList.adManagerId && i === (this.markersListAdPositionInStep - 1)) {
                        return Bingo.Map.SearchList.getAdZone(adNumber) + this.generateOfferToList(itemId);
                    }
                    return this.generateOfferToList(itemId);
                })
                .join('');
            this.appendItemsToListElement(this.getFuzzyResultsListElement(), fuzzyListElementHtmlToLoad);
        }
    }

    if (Bingo.Map.SearchList.adManagerId) {
        Bingo.AdManager.init(`js-ad-manager-zone-search-${adNumber}`);
    }

    this.checkToShowResults();

    this.askForInfo(undefined, true);
};

Bingo.Map.SearchList.prototype.parseDefaultLocation = function (locationSelector) {
    const locations = $(`#${locationSelector}`);
    if (locations.length !== 1) {
        return null;
    }
    const location = locations[0];
    if ($(location).data('defaultLocation') && $(location).data('defaultCoordinates')) {
        return {
            location: $(location).data('defaultLocation'),
            coordinates: this.extractCoordinates($(location).data('defaultCoordinates')),
        };
    }
    return null;
};

Bingo.Map.SearchList.prototype.addCenterButton = function () {
    // Overwrites behaviour from PositionSelection (parent)
    const self = this;
    this.addButton(google.maps.ControlPosition.RIGHT_TOP, 'gm-location-btn', () => {
        self.fitBounds();
    });
};

Bingo.Map.SearchList.prototype.fitBounds = function () {
    if (this.initialized === false) {
        return;
    }
    const defaultBounds = new google.maps.LatLngBounds();
    const searchAreaBounds = this.getSearchAreaBounds(new google.maps.LatLngBounds());
    if (searchAreaBounds.equals(defaultBounds) !== true) {
        if (Object.keys(this.markers).length > 0) {
            // Try to fit all the markers to the viewport
            this.fitBoundsToMarkers(this.markers, searchAreaBounds);
        } else {
            // No markers found, but user has defined some search area (polygon, circle, locality ...)
            this.getArea().fitBounds(searchAreaBounds);
        }
    } else {
        // Default view
        let location = {lat: Bingo.Map.DEFAULT_LOCATION.lat, lng: Bingo.Map.DEFAULT_LOCATION.long};
        if (this.userLocation) {
            location = this.userLocation;
        }
        this.getArea().panTo(location);
        this.getArea().setZoom(Bingo.Map.DEFAULT_ZOOM);
    }
};

Bingo.Map.SearchList.prototype.getSearchAreaBounds = function (bounds) {
    // Show custom localities (polygon, circles, ...)
    if (this._circle !== null) {
        bounds = this._circle.getBounds();
    } else if (this._polygon !== null) {
        bounds = this._polygon.getBounds();
    }
    // Show administrative divisions (regions, countries, towns, ...)
    if (this._localitiesDrawings.length > 0) {
        this._localitiesDrawings.forEach((locality) => {
            if (locality instanceof google.maps.Polygon) {
                locality.getPath().forEach((point) => { bounds.extend(point); });
            } else if (locality instanceof google.maps.Circle) {
                bounds.extend(locality.getBounds().getNorthEast());
                bounds.extend(locality.getBounds().getSouthWest());
            }
        });
    }

    return bounds;
};

Bingo.Map.SearchList.prototype.fitBoundsToMarkers = function (markers, bounds) {
    // Show all the markers on the map
    for (const index in markers) {
        bounds.extend(markers[index].position);
    }
    this.getArea().fitBounds(bounds);
};

Bingo.Map.SearchList.prototype.getResultsListElement = function () {
    const elems = $(`#${this.resultListSelector} .results`);
    if (elems.length > 0) {
        return elems[0];
    }
    return null;
};
Bingo.Map.SearchList.prototype.getFuzzyResultsListElement = function () {
    const elems = $(`#${this.resultListSelector} .fuzzy-results`);
    if (elems.length > 0) {
        return elems[0];
    }
    return null;
};

Bingo.Map.SearchList.prototype.disableMap = function () {
    Bingo.LocalStorage.set(this.VIEW_TYPE_KEY, this.VIEW_TYPE_LIST);
    this.showMap = false;
    $('.js-header').removeClass('-hiddenOnMobile');
    $('#block-content').removeClass('container-fluid px-0').addClass('container');
    $('.js-search__contentArea').addClass('-list').removeClass('-map');
    $('.js-search__mapArea').addClass('-hidden');
    $('.js-layout__footer').removeClass('-hidden');
    $('.map-options-switch').addClass('invisible');
    $('.js-showMap-list').addClass('d-none');
    $('.js-showMap-map').removeClass('d-none');
    $('.js-offerFilter').removeClass('-mapView').addClass('-listView');
    $('.js-box__agentBox').removeClass('-agentBoxWide');
    this.reloadSearchResultsGrid();
    $(`#${this.mapSelector}`).trigger('disableMap');
    this.onResize();
};

Bingo.Map.SearchList.prototype.enableMap = function () {
    Bingo.LocalStorage.set(this.VIEW_TYPE_KEY, this.VIEW_TYPE_MAP);
    this.showMap = true;
    $('.js-header').addClass('-hiddenOnMobile');
    $('#block-content').removeClass('container').addClass('container-fluid px-0');
    $('.js-search__contentArea').addClass('-map').removeClass('-list');
    $('.js-search__mapArea').removeClass('-hidden');
    $('.js-layout__footer').addClass('-hidden');
    $('.map-options-switch').removeClass('invisible');
    $('.js-showMap-list').removeClass('d-none');
    $('.js-showMap-map').addClass('d-none');
    $('.js-offerFilter').addClass('-mapView').removeClass('-listView');
    $('.js-box__agentBox').addClass('-agentBoxWide');
    this.reloadSearchResultsGrid();
    $(`#${this.mapSelector}`).trigger('enableMap');
    this.fitBounds();
    this.onResize();
};

Bingo.Map.SearchList.prototype.setMobileMapOpened = function (opened) {
    this.mobileMapOpened = opened;
};

Bingo.Map.SearchList.prototype.hideHelp = function () {
    $(`#${this.resultListSelector} .help`).addClass('d-none');
};

Bingo.Map.SearchList.prototype.hideResults = function () {
    $(`#${this.resultListSelector} .results`).addClass('d-none');
};

Bingo.Map.SearchList.prototype.showResults = function () {
    $(`#${this.resultListSelector} .results`).removeClass('d-none');
};

Bingo.Map.SearchList.prototype.hideFuzzyResults = function () {
    $(`#${this.resultListSelector} .fuzzy-results`).addClass('d-none');
};

Bingo.Map.SearchList.prototype.showFuzzyResults = function () {
    $(`#${this.resultListSelector} .fuzzy-results`).removeClass('d-none');
};

Bingo.Map.SearchList.prototype.hideNoResults = function () {
    $(`#${this.resultListSelector} .no-results`).addClass('d-none');
};

Bingo.Map.SearchList.prototype.showNoResults = function () {
    $(`#${this.resultListSelector} .no-results`).removeClass('d-none');
};

Bingo.Map.SearchList.prototype.hidePagination = function () {
    $(`#${this.resultListSelector} .paginator`).addClass('d-none');
};

Bingo.Map.SearchList.prototype.showPagination = function () {
    $(`#${this.resultListSelector} .paginator`).removeClass('d-none');
};

Bingo.Map.SearchList.prototype.hideFuzzyPagination = function () {
    $(`#${this.resultListSelector} .fuzzy-paginator`).addClass('d-none');
};

Bingo.Map.SearchList.prototype.showFuzzyPagination = function () {
    $(`#${this.resultListSelector} .fuzzy-paginator`).removeClass('d-none');
};


Bingo.Map.SearchList.prototype.hideFuzzyResultsHeading = function () {
    $(`#${this.resultListSelector} .fuzzy-results-heading`).addClass('d-none');
};

Bingo.Map.SearchList.prototype.showFuzzyResultsHeading = function () {
    $(`#${this.resultListSelector} .fuzzy-results-heading`).removeClass('d-none');
};

Bingo.Map.SearchList.prototype.hideResultsOptions = function () {
    $(`#${this.resultListSelector} .results-options`).addClass('d-none');
};

Bingo.Map.SearchList.prototype.showResultsOptions = function () {
    $(`#${this.resultListSelector} .results-options`).removeClass('d-none');
};

Bingo.Map.SearchList.prototype.hideResultsHardlimit = function () {
    $(`#${this.resultListSelector} .results-hardlimit`).addClass('d-none');
};

Bingo.Map.SearchList.prototype.showResultsHardlimit = function () {
    $(`#${this.resultListSelector} .results-hardlimit`).removeClass('d-none');
};

Bingo.Map.SearchList.prototype.hideFuzzyResultsHardlimit = function () {
    $(`#${this.resultListSelector} .fuzzy-results-hardlimit`).addClass('d-none');
};

Bingo.Map.SearchList.prototype.showFuzzyResultsHardlimit = function () {
    $(`#${this.resultListSelector} .fuzzy-results-hardlimit`).removeClass('d-none');
};

Bingo.Map.SearchList.prototype.deleteSearchHeading = function () {
    $(`#${this.searchNameSelector}`).html('');
};

Bingo.Map.SearchList.prototype.populateResultsCount = function (text) {
    $(`#${this.resultListSelector} .results-count`).text(text);
    $('.js-searchResults__totalCountText').text(text);
};

Bingo.Map.SearchList.prototype.showResultsCount = function () {
    $(`#${this.resultListSelector} .results-count`).removeClass('d-none');
    $('.js-searchResults__totalCountText').removeClass('d-none');
};

Bingo.Map.SearchList.prototype.hideResultsCount = function () {
    $(`#${this.resultListSelector} .results-count`).addClass('d-none');
    $('.js-searchResults__totalCountText').addClass('d-none');
};

Bingo.Map.SearchList.prototype.populateResultsSortCriterion = function (value) {
    const current = $('.results-options input[data-sorting-selected]');
    current.attr('data-sorting-selected', value);
    current.val(
        $(`.results-options a[data-sorting="${value}"]`).text(),
    );
};

Bingo.Map.SearchList.prototype.search = function (query) {
    this.query = query;
    this.load(false);
};

Bingo.Map.SearchList.prototype.getBoundingBoxPolygon = function () {
    const boundingBox = this.getArea().getBounds();
    if (typeof boundingBox !== 'undefined') {
        let ne = boundingBox.getNorthEast();
        let sw = boundingBox.getSouthWest();
        prec = 6;

        // Fixes invalid search map bounding area on mobile phones
        // The bounding box is is empty area as the map has not been displayed yet -> predefined window
        if (sw.lat() === ne.lat() && sw.lng() === ne.lng()) {
            sw = Bingo.Map.DEFAULT_BOUNDING_BOX.sw;
            ne = Bingo.Map.DEFAULT_BOUNDING_BOX.ne;
        }

        //  create bounding box polygon
        return `${sw.lat().toFixed(prec)},${sw.lng().toFixed(prec)};${
            sw.lat().toFixed(prec)},${ne.lng().toFixed(prec)};${
            ne.lat().toFixed(prec)},${ne.lng().toFixed(prec)};${
            ne.lat().toFixed(prec)},${sw.lng().toFixed(prec)};${
            sw.lat().toFixed(prec)},${sw.lng().toFixed(prec)}`;
    }
    return null;
};

Bingo.Map.SearchList.prototype.load = function (disableSpinner, keepPrevious) {
    const data = this.query.data;
    data.limit = this.LIMIT;
    data.offset = this.offset;
    data.limit2 = this.LIMIT;
    data.offset2 = this.offset2;

    const self = this;
    const settings = {
        type: this.query.type,
        url: this.query.url,
        data,
        success(returnData) {
            if (!self.isResponseValid(returnData)) {
                return;
            }
            self.hideHelp();
            if (!keepPrevious) {
                self.reset();
            }
            self.populateResults(returnData, keepPrevious);
            $('#frm-offerSearch-offerFilterForm-form').attr('action', self.query.url);
        },
    };

    if (disableSpinner) {
        settings.disableSpinner = true;
    }
    if (this.appendToXhr) {
        $.extend(settings, this.appendToXhr);
    }

    this.hideResultsCount();

    $.nette.ajax(settings);
};

Bingo.Map.SearchList.prototype.isResponseValid = function (data) {
    if (data.error && data.error.code === 1001) {
        return false;
    }

    return true;
};

Bingo.Map.SearchList.prototype.setAds = (id) => {
    if (typeof googletag !== 'undefined' && typeof googletag.pubads === 'function') {
        googletag.pubads().refresh();
    }
    window.googletag = window.googletag || {cmd: []};
    googletag.cmd.push(() => {
        if (!Bingo.Map.SearchList.adsSlotsDefined) {
            googletag.defineSlot(`/${id}/Search`, [300, 366], 'search').addService(googletag.pubads());
            for (let i = 2; i <= 10; i++) {
                googletag.defineSlot(`/${id}/Search${i}`, [300, 366], `search${i}`).addService(googletag.pubads());
            }
            Bingo.Map.SearchList.adsSlotsDefined = true;
        }
        googletag.pubads().enableSingleRequest();
        googletag.enableServices();
        googletag.pubads().addEventListener('slotRenderEnded', () => {
            $('.js-searchResultsGrid-itemAd').each(function () {
                if ($(this).find('.js-Ad > div').html().length === 0) {
                    $(this).remove();
                }
            });
        });
    });
};

Bingo.Map.SearchList.prototype.populateResults = function (data, keepPrevious = false) {
    if (!data.hasOwnProperty('normal') || !data.hasOwnProperty('fuzzy')) {
        return;
    }
    const normal = data.normal;
    const fuzzy = data.fuzzy;
    let sorting = normal.meta.sorting;
    if (!sorting) {
        sorting = 'newest';
    }

    if (JSON.stringify(this.localities) !== JSON.stringify(data.localities)) {
        this.localities = data.localities;
        if (data.localities.length !== 0) {
            this.redrawLocalitiesDrawings();
        } else if (this._circle === null && this._polygon === null) {
            //  no localities selected, but also no polygon or circle drawing - used when changing locality in map
            this.unsetDrawings();
        }
    }

    this.markersInfosSizeActualLimit = this.markersInfosSizeStart;
    this.markersInfosSize = 0;
    this.toLoad = {
        normal: [],
        fuzzy: [],
    };
    // When there are no more data we hide pagination or show a message when there are no results at all
    if (normal.meta.total < 1 && fuzzy.meta.total < 1) {
        this.showNoResults();
        this.checkMarkerThencloseInfoWindow();
        return;
    }

    this.showResults();
    this.showResultsOptions();

    if (normal.meta.hardlimited) {
        this.showResultsHardlimit();
    }
    if (fuzzy.meta.hardlimited) {
        this.showFuzzyResultsHardlimit();
    }

    this.populateResultsCount(normal.meta.totalText);
    if (normal.meta.total > 0) {
        this.showResultsCount();
    }

    this.populateResultsSortCriterion(sorting);

    if (!keepPrevious) {
        this.unsetAllMarkers();
        this.clusterer.clearMarkers();
    }

    const listElement = this.getResultsListElement();
    let listElementHtml = '';

    for (let i = 0; i < normal.data.length; i++) {
        this.addMarker(normal.data[i]);
        if (listElement) {
            if (this.markersInfosSize < this.markersInfosSizeActualLimit) {
                listElementHtml += this.generateOfferToList(normal.data[i].itemId);
                this.markersInfosSize = this.markersInfosSize + 1;
            }
            this.toLoad.normal.push(normal.data[i].itemId);
        }
        if (Bingo.Map.SearchList.adManagerId && ((i === (this.markersListAdPositionInStep - 2) && normal.data.length > 1) || normal.data.length === 1)) {
            listElementHtml += Bingo.Map.SearchList.getAdZone(1);
        }
    }

    if (this.markersInfosSize <= this.markersInfosSizeStep) {
        listElementHtml += this.getFirstPageAppendedContent();
    }

    listElement.innerHTML = listElementHtml;

    const fuzzyListElement = this.getFuzzyResultsListElement();
    let fuzzyListElementHtml = '';
    for (let j = 0; j < fuzzy.data.length; j++) {
        if (this._circle === null && this._polygon === null) {
            this.addMarker(fuzzy.data[j]);
        }
        if (fuzzyListElement) {
            if (this.markersInfosSize < this.markersInfosSizeActualLimit) {
                fuzzyListElementHtml += this.generateOfferToList(fuzzy.data[j].itemId);
                this.markersInfosSize = this.markersInfosSize + 1;
            }
            this.toLoad.fuzzy.push(fuzzy.data[j].itemId);
        }
    }
    fuzzyListElement.innerHTML = fuzzyListElementHtml;

    this.checkToShowResults();

    this.checkMarkerThencloseInfoWindow();

    this.askForInfo(undefined, true);
    // Post init
    Bingo.reinitNetteAjax();

    // Initialize carousel
    Bingo.PreviewGallery.initMultiple('.js-preview__carouselItems');

    if (Bingo.Map.SearchList.adManagerId) {
        Bingo.Map.SearchList.prototype.setAds(Bingo.Map.SearchList.adManagerId);
        Bingo.AdManager.init('js-ad-manager-zone-search-1');
    }

    this.initBlocksHover();
    this.reloadSearchResultsGrid();
};

Bingo.Map.SearchList.prototype.checkToShowResults = function () {
    if (this.getFuzzyResultsListElement().children.length > 0) {
        this.showFuzzyResultsHeading();
        this.showFuzzyResults();
    } else {
        this.hideFuzzyResultsHeading();
        this.hideFuzzyResults();
    }
    if (this.markersInfosSize >= this.toLoad.normal.length + this.toLoad.fuzzy.length) {
        this.hidePagination();
    } else {
        this.showPagination();
    }
};

Bingo.Map.SearchList.prototype.generateOfferToList = function (markerItemId) {
    let listElementHtml = '';
    if (typeof this.markersInfos[markerItemId] !== 'undefined') {
        listElementHtml = `<div class="marker_offer_info T-search__resultItem js-searchResultsGrid-item" data-id="${markerItemId}" id="marker_offer_info_${markerItemId}">${this.markersInfos[markerItemId][Bingo.Map.MarkerListInfoModes.info]}</div>`;
    } else {
        listElementHtml = `<div class="marker_offer_info T-search__resultItem js-searchResultsGrid-item" data-id="${markerItemId}"  id="marker_offer_info_${markerItemId}">${Bingo.Map.LoadingInfoBox}</div>`;
    }

    return listElementHtml;
};

Bingo.Map.SearchList.prototype.askForInfo = function (implicitId, manageLoadMoreDisability = false) {
    let notLoaded = [];
    //  find all the divs waiting to be populated with info
    const elms = document.getElementsByClassName('marker_offer_info');
    for (let i = 0; i < elms.length; i++) {
        const el = elms[i];
        if (el.children.length === 1 && el.firstElementChild.classList.contains('not-loaded')) {
            notLoaded.push(parseInt(el.dataset.id));
        }
    }

    if (typeof implicitId !== 'undefined' && notLoaded.indexOf(implicitId) < 0) {
        notLoaded.push(parseInt(implicitId));
    }

    //  filter ids-to-load with those, that are already being loaded
    notLoaded = notLoaded.filter(el => this.notLoaded.indexOf(el) < 0);

    //  removes duplicates
    notLoaded = [...new Set(notLoaded)];

    //  load all the data necessary info
    if (notLoaded.length > 0) {
        if (manageLoadMoreDisability) {
            this.loadMoreEnabled = false;
        }
        this.notLoaded = [...this.notLoaded, ...notLoaded];

        this.reloadSearchResultsGrid();

        $.ajax({
            type: 'POST',
            url: this.loadMarkerInfo,
            data: {
                ids: notLoaded.join(','),
            },
            success: (info) => {
                if (typeof info === 'object') {
                    this.notLoaded = this.notLoaded.filter(el => !info.hasOwnProperty(el));
                    this.markersInfos = Object.assign(this.markersInfos, info);
                    this.populateInfo(info);
                    //  Place loaded items
                    this.reloadSearchResultsGrid();
                }
            },
            complete: () => {
                if (manageLoadMoreDisability) {
                    this.loadMoreEnabled = true;
                }
            },
        });
    } else {
        if (manageLoadMoreDisability) {
            this.loadMoreEnabled = true; // re-enable if everything was found in cache and therefore no request was needed
        }
        //  Place items if it is loaded, but filter is changed
        this.reloadSearchResultsGrid();
    }
};

Bingo.Map.SearchList.prototype.populateInfo = function (newMarkerInfos) {
    const markerInfos = newMarkerInfos || this.markersInfos;

    // Populate markers (normal)
    for (const key in this.markers) {
        if (typeof markerInfos[key] !== 'undefined') {
            //  fill in data to markers
            this.markers[key]._info = markerInfos[key][Bingo.Map.MarkerListInfoModes.info];
            this.markers[key]._info2 = markerInfos[key][Bingo.Map.MarkerListInfoModes.info2];

            //  regenerate offers in result column
            $(`#marker_offer_info_${key}`).html(this.markers[key]._info);
            $(`#marker_offer_info2_${key}`).html(this.markers[key]._info2);

            //  Click listeners on markers to open infobox windows
            this.markers[key].addListener('click', () => {
                if (this.window) {
                    this.window.close();
                }
                if (this.markers[key]._info !== null) {
                    this.window = this.createInfoBox(this.markers[key]);
                }
            });
        }
    }
    // Populate without markers (fuzzy)
    const fuzzyResults = this.getFuzzyResultsListElement();
    if (fuzzyResults) {
        $(fuzzyResults).find('.not-loaded').each((number, item) => {
            const key = item.parentElement.dataset.id;
            if (typeof markerInfos[key] !== 'undefined') {
                $(`#marker_offer_info_${key}`).html(markerInfos[key][Bingo.Map.MarkerListInfoModes.info]);
                item.classList.remove('not-loaded');
            }
        });
    }

    // if the infobox is already opened, then regenerate that window
    if (typeof this.window !== 'undefined' && this.window !== null && this.window.itemId > 0) {
        if (typeof this.window.cluster === 'undefined' || !this.window.cluster) {
            this.window.close();
            this.window = this.createInfoBox(this.markers[this.window.itemId]);
        }
    }
    Bingo.reinitNetteAjax();

    // Initialize carousel
    Bingo.PreviewGallery.initMultiple('.js-preview__carouselItems');

    // Initialize miniatures in infowindow
    Bingo.ImageController.init('google-info-bubble');
};


Bingo.Map.SearchList.prototype.reset = function () {
    // Reset visibility to default state
    this.hideFuzzyResultsHeading();
    this.hideFuzzyResults();
    this.hideResults();
    this.hideNoResults();
    this.hideResultsOptions();
    this.hidePagination();
    this.hideResultsHardlimit();
    this.hideFuzzyResultsHardlimit();
    // Reset pagination
    this.offset = 0;
    this.offset2 = 0;
    // Remove markers (from map)
    this.unsetAllMarkers();
    this.clusterer.clearMarkers();

    // Clear results area
    const listElement = this.getResultsListElement();
    if (listElement) {
        listElement.innerHTML = '';
    }
    // Clear fuzzy results area
    const fuzzyListElement = this.getFuzzyResultsListElement();
    if (fuzzyListElement) {
        fuzzyListElement.innerHTML = '';
    }
};


Bingo.Map.SearchList.prototype.unsetAllMarkers = function () {
    for (const itemId in this.markers) {
        const marker = this.markers[itemId];
        marker.setMap(null);
        if (marker._label) {
            marker._label.setMap(null);
        }
    }

    this.markers = {};
};

Bingo.Map.SearchList.prototype.addMarker = function (item) {
    if (this.markers.hasOwnProperty([item.id])) {
        return;
    }
    const location = new google.maps.LatLng(item.location.lat, item.location.lng);

    let info = Bingo.Map.LoadingInfoBoxBig;
    if (item.info) {
        info = item.info;
    } else if (typeof this.markersInfos[item.itemId] !== 'undefined') {
        info = this.markersInfos[item.itemId][Bingo.Map.MarkerListInfoModes.info];
    }

    let info2 = Bingo.Map.LoadingInfoBoxSmall;
    if (item.info2) {
        info2 = item.info2;
    } else if (typeof this.markersInfos[item.itemId] !== 'undefined') {
        info2 = this.markersInfos[item.itemId][Bingo.Map.MarkerListInfoModes.info2];
    }
    const marker = new google.maps.Marker({
        map: this.getArea(),
        anchorPoint: new google.maps.Point(0, -29),
        draggable: false,
        position: location,
        optimized: false,
        _itemId: item.itemId,
        _info: info,
        _info2: info2,
        _windowClass: (item.hasOwnProperty('windowClass')) ? item.windowClass : null,
        _instance: this,
        zIndex: 5000 - Object.keys(this.markers).length + this.offset * 10 + this.offset2 * 10,
        _zIndex: 5000 - Object.keys(this.markers).length + this.offset * 10 + this.offset2 * 10,
        label: {
            color: '#2D2F30',
            fontWeight: '700',
            fontSize: '12px',
            text: '1',
            fontFamily: 'Pangram',
        },
    });
    const isHighlighted = item.icon.toString().search('_highlighted') > 0;
    marker.setIcon({
        url: `/src/images/markers/${item.icon}.png?{{buildVersion}}`,
        origin: new google.maps.Point(0, 0),
        anchor: isHighlighted ? new google.maps.Point(23, 50) : new google.maps.Point(20, 42),
        size: isHighlighted ? new google.maps.Size(46, 54) : new google.maps.Size(40, 48),
        labelOrigin: {
            x: isHighlighted ? 23 : 20,
            y: isHighlighted ? 24 : 22,
        },
    });
    if (item.price) {
        const label = new MapLabel({
            text: item.price,
            map: this.getArea(),
            position: location,
            fontSize: 14,
            fontWeight: 'bold',
            fontColor: '#ffffff',
            strokeWeight: 12,
            strokeColor: Bingo.Map.Marker.COLOR[item.icon],
            align: 'center',
            zIndex: marker._zIndex,
        });
        marker.bindTo('position', label);
        marker._label = label;
    }
    marker.setPosition(location); // for some reason the position: location setting above is not enough, nor moving this above. Not doing so breaks clusterer.
    this.markers[marker._itemId] = marker;
    this.clusterer.addMarker(marker);

    marker.addListener('click', () => {
        if (Bingo.OfferFilterForm.mobileFilterOpened) {
            Bingo.OfferFilterForm.hideMobileFilters();
        }
        this.closeInfoWindow();
        this.window = this.createInfoBox(marker);
        if (typeof this.markersInfos[marker._itemId] === 'undefined') {
            this.askForInfo(marker._itemId);
        }
    });

    google.maps.event.addListener(marker, 'mouseover', () => {
        this.markerHover(marker);
    });
    google.maps.event.addListener(marker, 'mouseout', () => {
        this.markerDehover(marker);
    });
};


Bingo.Map.SearchList.prototype.findMarker = function (itemId) {
    if (this.markers.hasOwnProperty(itemId)) {
        return this.markers[itemId];
    }
    return null;
};

Bingo.Map.SearchList.prototype.initBlocksHover = function () {
    if (!this.resultListSelector) {
        return;
    }
    const self = this;
    $(`#${this.resultListSelector} div[data-marker-list-highlight]`).each((index, item) => {
        const el = $(item);
        if (el.data('marker-list-initialized')) {
            return;
        }
        el.hover(() => {
            const marker = self.findMarker(el.data('marker-list-highlight'));
            if (marker) {
                google.maps.event.trigger(marker, 'mouseover');

                const cluster = self.clusterer.getClusterWithMarker(marker);
                if (cluster) {
                    google.maps.event.trigger(cluster.getClusterIcon().getWrapper(), 'mouseover');
                }
            }
        }, () => {
            const marker = self.findMarker(el.data('marker-list-highlight'));
            if (marker) {
                google.maps.event.trigger(marker, 'mouseout');

                const cluster = self.clusterer.getClusterWithMarker(marker);
                if (cluster) {
                    google.maps.event.trigger(cluster.getClusterIcon().getWrapper(), 'mouseout');
                }
            }
        });
        el.data('marker-list-initialized', true);
    });
};

Bingo.Map.SearchList.prototype.setCallbackOnNoLocation = function (callback) {
    this.onNoLocationCallback = callback;
};

Bingo.Map.SearchList.prototype.addAjaxSettings = function (settings) {
    this.appendToXhr = settings;
};

Bingo.Map.SearchList.prototype.noLocation = function () {
    if (this.onNoLocationCallback) {
        this.onNoLocationCallback();
    }
};

Bingo.Map.SearchList.prototype.appendItemsToListElement = function (listElement, itemsHtml) {
    if (listElement !== null) {
        const $items = $(itemsHtml);
        $(listElement).append($items);
        if (this.searchGridEnabled) {
            $(listElement).masonry('appended', $items);
        }
    }
};

Bingo.Map.SearchList.prototype.initSearchResultsGrid = function () {
    const listElement = this.getResultsListElement();
    const listElementFuzzy = this.getFuzzyResultsListElement();
    const masonryOptions = {
        columnWidth: 300,
        horizontalOrder: true,
        itemSelector: '.js-searchResultsGrid-item',
        gutter: 15,
        isFitWidth: true,
        transitionDuration: 0,
    };
    if (listElement !== null) {
        $('.js-searchResultsGrid').masonry(masonryOptions);
        this.searchGridEnabled = true;
    }
    if (listElementFuzzy !== null) {
        $('.js-searchResultsGrid--fuzzy').masonry(masonryOptions);
        this.searchGridEnabled = true;
    }
};

Bingo.Map.SearchList.prototype.reloadSearchResultsGrid = function () {
    const listElement = this.getResultsListElement();
    const listElementFuzzy = this.getFuzzyResultsListElement();
    if (this.searchGridEnabled === true) {
        if (listElement !== null) {
            setTimeout(() => {
                $('.js-searchResultsGrid').masonry('reloadItems');
                $('.js-searchResultsGrid').masonry('layout');
            }, 0);
        }
        if (listElementFuzzy !== null) {
            setTimeout(() => {
                $('.js-searchResultsGrid--fuzzy').masonry('reloadItems');
                $('.js-searchResultsGrid--fuzzy').masonry('layout');
            }, 0);
        }
    }
};

Bingo.Map.SearchList.prototype.destroySearchResultsGrid = function () {
    const listElement = this.getResultsListElement();
    const listElementFuzzy = this.getFuzzyResultsListElement();
    if (this.searchGridEnabled === true) {
        if (listElement !== null) {
            $('.js-searchResultsGrid').masonry('destroy');
            this.searchGridEnabled = false;
        }
        if (listElementFuzzy !== null) {
            $('.js-searchResultsGrid--fuzzy').masonry('destroy');
            this.searchGridEnabled = false;
        }
    }
};
